import React, { FC } from "react";
import { useSelector } from "react-redux";

import {
  TextareaAutosize,
  Box,
} from "@material-ui/core";
import { selectImageToken } from "../../../features/userSlice";
import useImageLoader from "../../organisms/photo/useImageLoader"

/**
 * 店舗確認表管理者分析の小項目添付表示用部品
 * 
 * @param rowData 小項目指定時の1店舗のデータ（各週含む）
 * @param suffix 添え字
 * @param element 小項目のチェック結果アイコン（〇、×等）
 * @returns 添付画像・コメントを追加した要素
 */
const TenpoCheckManagerAnalysisSmallItemAttach: FC<{
  rowData: any;
  suffix: string;
  element: JSX.Element;
}> = ({ rowData, suffix, element }) => {
  const imageToken = useSelector(selectImageToken);
  function getImageFile(imagePath: string) {
    console.log(`getImageFile called with imagePath: ${imagePath}, suffix: ${suffix}`);
    if (imagePath === undefined || imagePath === "" || imagePath === "[]") {
      return ""; // 空文字列を返すことで、useImageLoaderが画像ロードをスキップする
    }
    const imagePathArray = imagePath.replace(/[\[\]]/g, "").split(",");
    if (imagePathArray.length === 0 || imagePathArray[0] === "") {
      return "";
    }
    const fullUrl = process.env.REACT_APP_CLOUD_STORAGE_URL +
      imagePathArray[0] +
      "?access_token=" +
      imageToken;
    console.log(`getImageFile returning URL: ${fullUrl}`);
    return fullUrl;
  }

  // 画像読み込み
  console.log(`TenpoCheckManagerAnalysisSmallItemAttach - rowData:`, rowData);
  console.log(`photoFilePath${suffix}:`, rowData[`photoFilePath${suffix}`]);
  console.log(`commentFilepathGcs${suffix}:`, rowData[`commentFilepathGcs${suffix}`]);
  const {loading: photoLoading, photo: photoSrc} = useImageLoader(getImageFile(rowData[`photoFilePath${suffix}`]));
  const {loading: commentPhotoLoading, photo: commentPhotoSrc} = useImageLoader(getImageFile(rowData[`commentFilepathGcs${suffix}`]));

  return (
    <Box
      display="flex"
      alignItems="center"
      style={{ justifyContent: 'flex-start' }}
    >
      <Box p={1}>
        {element}
      </Box>
      <Box p={1}>
        {rowData[`photoFilePath${suffix}`] && rowData[`photoFilePath${suffix}`] !== "[]" && rowData[`photoFilePath${suffix}`] !== "" ? (
          <img
            alt=""
            src={photoSrc}
            height={photoLoading ? "100" : "200"}
            style={{
              width: photoLoading ? "100px" : "200px",
              WebkitAppearance: "none",
            }}
          />
        ) : (
          <></>
        )}
      </Box>
      <Box p={1}>
        {(rowData[`commentHandwriteFlag${suffix}`] && rowData[`commentHandwriteFlag${suffix}`] === "1") ? (
          <img
            alt=""
            src={commentPhotoSrc}
            height={commentPhotoLoading ? "100" : "200"}
            style={{
              width: commentPhotoLoading ? "100px" : "200px",
              WebkitAppearance: "none",
            }}
          />
        ) :(rowData[`commentHandwriteFlag${suffix}`] && rowData[`commentHandwriteFlag${suffix}`] === "0" && rowData[`userInputComment${suffix}`]) ? (
          <TextareaAutosize
            rowsMax={3}
            maxLength={4000}
            placeholder={""}
            value={rowData[`userInputComment${suffix}`]}
            style={{
              height: "190px",
              width: "190px",
              fontSize: "16px",
              borderRadius: "8px",
              padding: "0px",
              border: "none",
              resize: "none",
              outline: "none",
              overflow: "hidden",
              
            }}
          />
          ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};
export default TenpoCheckManagerAnalysisSmallItemAttach;
